import _ from 'lodash';

function canAcessRessouce(vm, customStatus){
  let canAccess = true;
  if(customStatus.roles!=null && customStatus.roles.length>0){
    canAccess=false;
    _.forEach(customStatus.roles, r=>{
      if(vm.$can(r.role, r.ressource))canAccess=true;
    })
  }
  return canAccess;
}

export default {
  canShow({customStatus, actualStatus, inventory, testedStatus, conditions, customStatuses, vm }){
    if (actualStatus == null) {
       // console.log('actualStatus = null');
       return false;
    }
    let cond = null;

    if(customStatus!=null){

      if (!_.isEmpty(customStatus.inventories)) {
        const inventoryCond = _.find(customStatus.inventories, i => i === inventory.code)
        if (inventoryCond == null) {
          return false;
        }
      }

      cond = _.find(customStatus.condition, cond=>{return cond==actualStatus.code});
      let previousStatusConditionSatisfied = cond!=null;
      if(previousStatusConditionSatisfied){
        previousStatusConditionSatisfied = canAcessRessouce(vm,customStatus)
      }
      return previousStatusConditionSatisfied;
    }else{
      cond = _.find(conditions, condition => condition === actualStatus.code)

      if(cond!=null){
        return true;
      }

      //OVERRIDE BY Custom STATUS
      let customConditions = [];
      _.forEach(customStatuses, customStatus=>{

        _.forEach(customStatus.before, cond=>{

          if(cond==testedStatus){
            //On ajoute l'état associé du custom status
            customConditions.push(customStatus.actionsMap[customStatus.action].associatedStatus);
          }
        })
      })

      if(customConditions.length>0){
        let overrideCond =_.find(customConditions, condition=>{return condition==actualStatus.code});
        let previousStatusConditionSatisfied = overrideCond!=null;

        return previousStatusConditionSatisfied;
      }
      else{

        return true;
        if(conditions.length==0){
          return true;
        }
      }

      return cond!=null
    }

  }
}
